import { APIGenerator } from "../../../utils/genericAPI/GenerateAPI"
import { Client, ClientPatch } from "../types/clients.types"

export const BASE_URL_CLIENT =   process.env.REACT_APP_BACKEND_API_URL +'/api/v1/admin/clients'
export const BASE_URL_CLIENT_EXTEND =   process.env.REACT_APP_BACKEND_API_URL +'/api/v1/admin/clients/extend'

export const clientAPI = new APIGenerator<Client, ClientPatch, ClientPatch>(BASE_URL_CLIENT)


